import {
    IProps,
} from './types';

import classNames from 'classnames';
import React, {
    ChangeEvent,
    FC,
    KeyboardEvent,
} from 'react';

import {
    ErrorMessage,
} from 'components/other';

import {
    mapIconSrc,
} from './functions';

import styles from './StringInput.module.scss';

const StringInput: FC<IProps> = (props) => {
    const onChange = (e: ChangeEvent<HTMLInputElement>) => {
        let {value} = e.target;

        if (props.maxLength !== undefined) {
            if (value.length === props.maxLength + 1) {
                return;
            }

            value = value.slice(0, props.maxLength);
        }

        e.target.value = value;

        props.onChangeValue?.(e.target.value);
        props.onChange?.(e);
    };
    const onKeyDown = (e: KeyboardEvent<HTMLInputElement>) => {
        // @ts-ignore
        const {value, selectionStart, selectionEnd} = e.target;

        if (props.maxLength !== undefined) {
            if (value.length === props.maxLength) {
                const isSystem = e.metaKey || e.ctrlKey || e.altKey;
                const isSelected = selectionEnd - selectionStart > 0;

                if (e.key.length === 1 && !isSystem && !isSelected) {
                    e.preventDefault();
                }
            }
        }

        props.onKeyDown?.(e);
    };

    return (
        <div
            className={
                classNames(styles.stringInput, props.className, {
                    [styles.isSmall]: props.size === 'small',
                    [styles.isDisabled]: props.isDisabled,
                    [styles.isError]: props.isError,
                })
            }
        >
            {
                props.label &&
                <label className={styles.label}>
                    {props.label}
                </label>
            }
            {
                props.leftIcon &&
                <img
                    className={
                        classNames(styles.leftIcon, {
                            [styles.clickableIcon]: !!props.onClickIcon,
                            [styles.iconWithLabel]: !!props.label,
                        })
                    }
                    src={mapIconSrc(props.leftIcon)}
                    alt={''}
                    onClick={props.onClickIcon}
                />
            }
            <input
                className={
                    classNames(styles.input, {
                        [styles.inputWithLeftIcon]: !!props.leftIcon,
                        [styles.inputWithRightIcon]: !!props.rightIcon,
                    })
                }
                type={props.type}
                value={props.value}
                placeholder={props.placeholder}
                autoComplete={'off'}
                disabled={props.isDisabled}
                onChange={onChange}
                onFocus={props.onFocus}
                onBlur={props.onBlur}
                onKeyDown={onKeyDown}
            />
            {
                props.rightIcon &&
                <img
                    className={
                        classNames(styles.rightIcon, {
                            [styles.clickableIcon]: !!props.onClickIcon,
                            [styles.iconWithLabel]: !!props.label,
                        })
                    }
                    src={mapIconSrc(props.rightIcon)}
                    alt={''}
                    onClick={props.onClickIcon}
                />
            }
            <ErrorMessage
                className={styles.errorMessage}
                text={props.errorMessage ?? ''}
                size={props.size}
            />
        </div>
    );
};

export default StringInput;
